import { h, Component } from 'preact';
import { trackingProvider, DIMENSION } from '@cube/track';
import { TaboolaJs } from '../../taboola-js';

export const canRender = () => true;
export const getLink = ({ uri }) => uri;

@trackingProvider({
	[DIMENSION.componentpath]: 'TaboolaJs.Organic'
})
export class Card extends Component {

	render({ variant, slideNumber }) {

		let config = {};

		if ('P23-DCC-A' === variant) {
			let id = `taboola-dcc-slide${slideNumber}-js-v3-organic`;
			config = {
				taboolaJsParams: {
					mode: 'organic-dcc-thumbnails-v2',
					container: id,
					placement: `dcc-slide${slideNumber}-js-v3-organic`,
					target_type: 'mix'
				},
				id
			};
		}
		else {
			let id = `taboola-dcc-${slideNumber}`;
			config = {
				taboolaJsParams: {
					mode: 'organic-thumbnails-r',
					container: id,
					placement: `dcc-slide${slideNumber}-js-v2-organic`,
					target_type: 'mix'
				},
				id
			};
		}

		return 	(
			<TaboolaJs {...config} qeId="dcc-taboola-card" />
		);
	}
}

const Taboola = {
	canRender,
	getLink,
	Card
};
export default Taboola;
